// extracted by mini-css-extract-plugin
export var callCard = "_s0-0";
export var callMessageButton = "_s0-1";
export var helpIcon = "_s0-3";
export var helpIconContainer = "_s0-4";
export var verticalDivider = "_s0-2";